// extracted by mini-css-extract-plugin
export default {"BuildingMap":"BuildingMap_BuildingMap__6H8zI","map":"BuildingMap_map__6pO-f"};